import actions from '@/Core.Service.Domain/Controls/Thermostats/Store/actions.js';
import getters from '@/Core.Service.Domain/Controls/Thermostats/Store/getters.js';
import mutations from '@/Core.Service.Domain/Controls/Thermostats/Store/mutations.js';

const state = {
  thermostatsList: [],
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
